module.exports = __webpack_public_path__ + "assets/img/type2.310492e7.png";